import { useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: constants.divPadding,
      borderRadius: constants.radius.view,
      backgroundColor: theme.card.background,
    },
    title: {
      fontWeight: "bold",
    },
    left: {
      flexGrow: 1,
    },
  };

  return styles;
};
